import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Interaction } from '../../../models/interactions.model';
import {
  InteractionEditorStateEvent,
  InteractionEditorStateStatus,
} from '../models/interaction-editor.model';

@Injectable({
  providedIn: 'root',
})
export class InteractionEditorStateService {
  private readonly _interactionState = signal<Interaction | null>(null);

  private readonly _statusSubject = new BehaviorSubject<InteractionEditorStateStatus>(
    'idle'
  );
  private readonly _eventsSubject = new Subject<InteractionEditorStateEvent>();

  public readonly status$ = this._statusSubject.asObservable();
  public readonly events$ = this._eventsSubject.asObservable();

  public readonly interaction = this._interactionState.asReadonly();
  public readonly selectedQuestionId = signal<string | null>(null);
  public readonly selectedAnswerId = signal<string | null>(null);

  setState(value: Interaction) {
    this._interactionState.set(value);
  }

  clearState() {
    this._interactionState.set(null);

    this.selectedQuestionId.set(null);
    this.selectedAnswerId.set(null);
  }

  setStatus(value: InteractionEditorStateStatus) {
    this._statusSubject.next(value);
  }

  emitEvent(event: InteractionEditorStateEvent) {
    this._eventsSubject.next(event);
  }
}
